import React from 'react'
import BaseYouMayAlsoLikeTile from 'components/OfferList/OfferListTiles/YouMayAlsoLikeTile/BaseYouMayAlsoLikeTile'
import ProductTypeLabel from 'components/Luxkit/Label/ProductTypeLabel'
import FormatCurrency from 'components/Common/FormatCurrency'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Caption from 'components/Luxkit/Typography/Caption'
import findCheapestTourV2PurchasableOption from 'lib/tours/findCheapestTourV2PurchasableOption'
import useTourV2PurchasableOptionDetails from 'hooks/TourV2/useTourV2PurchasableOptionDetails'
import useTourV2VariationDetails from 'hooks/TourV2/useTourV2VariationDetails'
import TourV2UrgencyTags from 'components/Tours/TourV2UrgencyTags'

interface Props {
  offer: Tours.V2Offer;
}

function TourV2YouMayAlsoLikeTile(props: Props) {
  const { offer } = props

  const cheapestPurchasableOption = findCheapestTourV2PurchasableOption(offer)

  const variationId = cheapestPurchasableOption?.fkVariationId ?? Object.keys(offer.variations)[0]

  const variation = offer.variations[variationId]

  const purchasableOptionDetails = useTourV2PurchasableOptionDetails(cheapestPurchasableOption)
  const {
    durationInDaysCount,
  } = useTourV2VariationDetails(variation)

  return (
    <BaseYouMayAlsoLikeTile
      image={variation.images[0]}
      location={variation.countriesVisited.join(', ')}
      title={variation.name}
      walledGarden={false}
    >
      <BaseYouMayAlsoLikeTile.ImageBadges>
        <ProductTypeLabel productType={offer.productType} />
      </BaseYouMayAlsoLikeTile.ImageBadges>
      <BaseYouMayAlsoLikeTile.ContentTags>
        <TourV2UrgencyTags tags={offer.urgencyTags} />
      </BaseYouMayAlsoLikeTile.ContentTags>
      <BaseYouMayAlsoLikeTile.MainDescription>
        <Caption variant="large" weight="bold">{durationInDaysCount}, Tour</Caption>
      </BaseYouMayAlsoLikeTile.MainDescription>
      <BaseYouMayAlsoLikeTile.PriceDetails>
        <Caption variant="medium">{durationInDaysCount} from</Caption>
        <div>
          <BodyText variant="medium" weight="bold" as="span">
            <FormatCurrency value={purchasableOptionDetails.pricePerPerson} format="roundedDollar" />
          </BodyText>
          <BodyText variant="small" as="span">&nbsp;/person ({purchasableOptionDetails.roomTypeName})</BodyText>
        </div>
        {!!purchasableOptionDetails.valuedAt && (
          <Caption variant="medium" weight="bold" >Valued up to <FormatCurrency value={purchasableOptionDetails.valuedAt.price} /></Caption>
        )}
      </BaseYouMayAlsoLikeTile.PriceDetails>
    </BaseYouMayAlsoLikeTile>
  )
}

export default TourV2YouMayAlsoLikeTile
